import { createFileRoute, Link, useRouterState } from "@tanstack/react-router";
import { tFor } from "@/lib/i18n";
import type { Lang } from "@/lib/i18n/config";

/**
 * Alla adresser som inte matchar någon sida. Egen rutt (i stället för bara
 * rotens notFound) så att sidan kan säga noindex till sökmotorerna.
 */
export const Route = createFileRoute("/$")({
  head: (ctx) => {
    const pathname: string = (ctx as { location?: { pathname?: string } }).location?.pathname ?? "";
    const lang: Lang = pathname.startsWith("/en")
      ? "en"
      : pathname.startsWith("/es")
        ? "es"
        : "sv";
    const t = tFor(lang);
    return {
      meta: [
        { title: `${t("errors.notFoundTitle")} — Sellavo` },
        { name: "description", content: t("errors.notFoundBody") },
        { name: "robots", content: "noindex, follow" },
      ],
    };
  },
  component: NotFoundPage,
});

function NotFoundPage() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const lang: Lang = pathname.startsWith("/en")
    ? "en"
    : pathname.startsWith("/es")
      ? "es"
      : "sv";
  const t = tFor(lang);
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="font-heading text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">{t("errors.notFoundTitle")}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{t("errors.notFoundBody")}</p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            {t("common.toStartPage")}
          </Link>
        </div>
      </div>
    </div>
  );
}
